import { render } from "./CouponSection.vue?vue&type=template&id=2d95e6ab"
import script from "./CouponSection.vue?vue&type=script&lang=js"
export * from "./CouponSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__